export default __webpack_public_path__ + "static/media/cbw.a7f9e4f7.png";